import { axiosInstance as axios } from "./axiosInstance";

export const signUp = (name, surname, website, email, password) => {
    const config = {
        headers: {
            'accept': "application/json"
        }
    }
    const data = {
        name,
        surname,
        website,
        email,
        password,
    }
    return axios.post("/api/signup", data, config);
}

export const login = (email, password) => {
    const config = {
        headers: {
            'accept': "application/json"
        }
    }
    const data = {
        email,
        password
    }
    return axios.post("/api/login", data, config);
}

export const isAuthenticated = () => {
    return axios.get("/api/isAuthenticated");
}

export const getCompleted = () => {
    return axios.get(`/api/v2/contacts/completed`);
}

export const setCompleted = () => {
    return axios.post(`/api/v2/contacts/completed`);
}

export const getCompletedPayment = () => {
    return axios.get(`/api/hasCompletedPayment`);
}

export const completePayment = (hasCompletedPayment) => {
    const data = {
        hasCompletedPayment,
    }

    return axios.post(`/api/hasCompletedPayment`, data);
}

export const verifyDiscount = discountCode => {
    return axios.post("/api/v2/verify-discount", discountCode)
}

export const forgotPassword = email => {
    return axios.post("/api/forgot-password", email);
}

export const resetPassword = (token, email, password, passwordConfirmation) => {
    const data = {
        token,
        email,
        password,
        passwordConfirmation
    }
    return axios.post("/api/reset-password", data);
}